export default {
    API_ENDPOINT: `https://secret-garden-31013.herokuapp.com/api`
}